import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private commonApiService: CommonApiService) {}

  onBasicDetailUpdate(payload: any) {
    return this.commonApiService.update(APIURL.basicDetailsUpdate, payload);
  }

  onInviteUser(payload: any) {
    return this.commonApiService.post(APIURL.inviteUsers, payload);
  }
  
  onInviteUserV2(payload: any) {
    return this.commonApiService.post(APIURL.invite_user, payload);
  }
}
